import classes from "./MediaS.module.css";
import logo from "../../store/logo.png";
import {Button} from "@mui/material";
import {useState} from "react";

const MediaS = (props) =>{
    const isVideoUrl = (u) => /\.(mp4|webm|mov|m4v|avi|mkv)(\?.*)?$/i.test(String(u || ''));
    const isPdfUrl = (u) => /\.pdf(\?.*)?$/i.test(String(u || ''));
    const isHttpUrl = (u) => /^https?:\/\//i.test(String(u || '').trim());
    const isImageUrl = (u) => /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(String(u || ''));
    const getUrlHost = (u) => {
        try { return new URL(String(u)).host; } catch (_) { return ''; }
    };



    const delete_handler = () =>{
    props.delete(props.id)
    }
    const preview_handler = (e) =>{
        e.stopPropagation();
        props.preview(props.id)
    }
    const image_click_handler = () =>{
        props.preview(props.id)
    }
    const edit_handler = () =>{
        props.edit(props.id)
    }
    const visibilitySupported = typeof props.onVisibilityChange === 'function';
    const isVisible = props.isVisible !== false && props.isVisible !== 0;
    const toggleVisibility = (e) => {
        e.stopPropagation();
        if (!visibilitySupported) return;
        props.onVisibilityChange(!isVisible);
    };

    const RestaurantSetupCards =
        <div className={`${classes.main} ${classes.mainEle}`}>

        <div className={classes.mainPic} onClick={image_click_handler} style={{ cursor: 'pointer', position: 'relative' }}>
            {isVideoUrl(props.body?.imgURL) ? (
                <video
                    src={props.body.imgURL}
                    muted
                    preload="metadata"
                    playsInline
                    style={{ opacity: visibilitySupported && !isVisible ? 0.35 : 1, width: '100%', height: '100%', objectFit: 'cover' }}
                    onLoadedMetadata={(e) => {
                        try {
                            const v = e.currentTarget;
                            const t = Number.isFinite(v.duration) && v.duration > 1.1 ? 1 : 0;
                            v.currentTime = t;
                            v.pause();
                        } catch (_) {}
                    }}
                />
            ) : isPdfUrl(props.body?.imgURL) ? (
                <div
                    style={{
                        opacity: visibilitySupported && !isVisible ? 0.35 : 1,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#f3f3f3',
                        color: '#333',
                        fontWeight: 700
                    }}
                >
                    PDF
                </div>
            ) : (isHttpUrl(props.body?.imgURL) && !isImageUrl(props.body?.imgURL)) ? (
                <div
                    style={{
                        opacity: visibilitySupported && !isVisible ? 0.35 : 1,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6,
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#f3f3f3',
                        color: '#333',
                        padding: 10,
                        textAlign: 'center'
                    }}
                >
                    <div style={{ fontWeight: 800 }}>WEB</div>
                    <div style={{ fontSize: 12, opacity: 0.8, wordBreak: 'break-word' }}>
                        {getUrlHost(props.body?.imgURL) || props.body?.imgURL}
                    </div>
                </div>
            ) : props.body?.imgURL ? (
            <img
                src={props.body.imgURL}
                alt={props.text || ""}
                style={{ opacity: visibilitySupported && !isVisible ? 0.35 : 1 }}
            />
            ) : (
            <div style={{
                width: '100%', minHeight: 160, display: 'flex', alignItems: 'center',
                justifyContent: 'center', color: '#9aa0a6', fontSize: 13,
                background: '#f2f3f5', borderRadius: 8, textAlign: 'center', padding: 12
            }}>Žádný obrázek — nahraj přes „Change image"</div>
            )}
            {/* Zobrazit názvy displejů na obrázku jen pokud jsou k dispozici a nejsou všechny displeje */}
            {props.deviceNames && props.deviceNames.length > 0 && !(
                props.deviceNames.length === 1 && props.deviceNames[0] === 'All displays'
            ) && (
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    padding: '8px 12px',
                    fontSize: '12px',
                    fontWeight: 500,
                    textAlign: 'center',
                    borderBottomLeftRadius: '8px',
                    borderBottomRightRadius: '8px'
                }}>
                    {props.deviceNames.length === 1 
                        ? `Appears on: ${props.deviceNames[0]}`
                        : `Appears on: ${props.deviceNames.length} displays (${props.deviceNames.join(', ')})`
                    }
                </div>
            )}
        </div>
        <div className={classes.mainText}>
            {props.text.toUpperCase()}
            {visibilitySupported && !isVisible ? " (HIDDEN)" : ""}
        </div>
        <div className={classes.mainButt}>
            <Button variant="text" onClick={preview_handler}>Preview</Button>
            {typeof props.onUpdateDefaultScreen === 'function' && (
                <Button variant="text" color="primary" onClick={() => props.onUpdateDefaultScreen(props.id)}>Change image</Button>
            )}
            {visibilitySupported && !props.onUpdateDefaultScreen && (
                <Button
                    variant="text"
                    color={isVisible ? "warning" : "success"}
                    onClick={toggleVisibility}
                >
                    {isVisible ? "Hide" : "Show"}
                </Button>
            )}
            <Button variant="text" onClick={delete_handler}>Delete</Button>
        </div>
    </div>

    const MenuSetupCards =
        <div className={`${classes.main} ${classes.mainEle}`}>

            <div className={classes.mainPic} onClick={image_click_handler} style={{ cursor: 'pointer' }}>
                {isVideoUrl(props.body?.imgURL) ? (
                    <video
                        src={props.body.imgURL}
                        muted
                        preload="metadata"
                        playsInline
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onLoadedMetadata={(e) => {
                            try {
                                const v = e.currentTarget;
                                const t = Number.isFinite(v.duration) && v.duration > 1.1 ? 1 : 0;
                                v.currentTime = t;
                                v.pause();
                            } catch (_) {}
                        }}
                    />
                ) : isPdfUrl(props.body?.imgURL) ? (
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#f3f3f3',
                            color: '#333',
                            fontWeight: 700
                        }}
                    >
                        PDF
                    </div>
                ) : (isHttpUrl(props.body?.imgURL) && !isImageUrl(props.body?.imgURL)) ? (
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6,
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#f3f3f3',
                            color: '#333',
                            padding: 10,
                            textAlign: 'center'
                        }}
                    >
                        <div style={{ fontWeight: 800 }}>WEB</div>
                        <div style={{ fontSize: 12, opacity: 0.8, wordBreak: 'break-word' }}>
                            {getUrlHost(props.body?.imgURL) || props.body?.imgURL}
                        </div>
                    </div>
                ) : (
                <img src={props.body.imgURL} alt={props.text || ""}/>
                )}
            </div>
            <div className={classes.mainText}>{props.text.toUpperCase()}</div>
            <div className={classes.mainButt}>
                <Button color={"success"} variant="text" onClick={preview_handler}>Preview</Button>
                <Button color={"success"} variant="text" onClick={edit_handler}>Update</Button>

            </div>
        </div>

const result = props.typ == 1? RestaurantSetupCards: MenuSetupCards

    return result
}

export default MediaS